import React, { useRef } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import DownloadIcon from '@mui/icons-material/Download';
import Stack from '@mui/material/Stack';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { find, findIndex } from 'lodash';
import { Link } from 'react-router-dom';

import { useUploadFileMutation } from 'app/apis/upload.api';

const ManuallyUploadedBooklet = ({ name }) => {
  const { t } = useTranslation();
  const [uploadFile, { isLoading }] = useUploadFileMutation();
  const uploadInputRef = useRef(null);
  const uploadButtonRef = useRef(null);

  const upload = (lang) => {
    uploadInputRef.current.click();
    uploadButtonRef.current = lang;
  }

  const onUpload = (e, field) => {
    let selectedFile = e.target.files[0];
    let tmp = [...field.value];
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('uploadType', 'manuallyUploadedBooklet');

    uploadFile(formData).unwrap().then((resp) => {
      let index = findIndex(tmp, e => e.lang === uploadButtonRef.current);
      if (index === -1) {
        tmp.push({
          lang: uploadButtonRef.current,
          format: resp.format,
          uri: resp.temporaryLocation.replace('/temp/', '/private/temp/')
        })
      } else {
        tmp[index].uri = resp.temporaryLocation.replace('/temp/', '/private/temp/')
      }
      field.onChange(tmp);
    });
  }

  const deleteBooklet = (field, lang) => {
    let index = findIndex(field.value, e => e.lang === lang);
    if (index === -1)
      return;
    let tmp = [...field.value];
    tmp.splice(index, 1)
    field.onChange(tmp);
  }

  return (
    <Controller
      name={name}
      render={({ field }) => {
        if (!field.value) field.value = [];
        return (
          <Grid container>
            <Grid item xs={6}>
              <Typography fontWeight={'bold'} mb={1}>
                English manually uploaded booklet
              </Typography>
              {!find(field.value, r => r.lang === 'en') ? (
                <LoadingButton
                  variant="contained"
                  loading={isLoading}
                  onClick={() => upload('en')}
                >
                  Upload English
                </LoadingButton>
              ) : (
                <Stack direction={'row'} spacing={1} style={{ cursor: 'pointer' }}>
                  <Button
                    variant='contained' color='error'
                    onClick={() => deleteBooklet(field, 'en')}
                  >
                    Delete English
                  </Button>
                  <Box
                    component={Link} target="_blank"
                    style={{ cursor: 'pointer', color: 'black', textDecoration: 'none' }}
                    to={`/api/download/?uri=${find(field.value, r => r.lang === 'en').uri}`}
                  >
                    Download
                    <DownloadIcon/>
                  </Box>
                </Stack>
              )}
            </Grid>
            <Grid item xs={6}>
              <Typography fontWeight={'bold'} mb={1}>
                French manually uploaded booklet
              </Typography>
              {!find(field.value, r => r.lang === 'fr') ? (
                <LoadingButton
                  variant="contained"
                  loading={isLoading}
                  onClick={() => upload('fr')}
                >
                  Upload French
                </LoadingButton>
              ) : (
                <Stack direction={'row'} spacing={1} style={{ cursor: 'pointer' }}>
                  <Button
                    variant='contained' color='error'
                    onClick={() => deleteBooklet(field, 'fr')}>
                    Delete French
                  </Button>
                  <Box
                    component={Link} target="_blank"
                    style={{ cursor: 'pointer', color: 'black', textDecoration: 'none' }}
                    to={`/api/download/?uri=${find(field.value, r => r.lang === 'fr').uri}`}
                  >
                    Download
                    <DownloadIcon/>
                  </Box>
                </Stack>
              )}
            </Grid>
            <input
              type='file'
              onChange={(e) => onUpload(e, field)}
              style={{ display: 'none' }}
              accept='.pdf'
              ref={uploadInputRef}
            />
          </Grid>
        )
      }}
    />
  )
};

export default ManuallyUploadedBooklet;
